import { Currency } from '@seapoint/server/enums';
import { TriangleAlert } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type CurrencyAccountNotFoundProps = {
  currency: Currency;
  onOpenAccount: () => void;
  onCancelTransfer: () => void;
};

export const CurrencyAccountNotFound = ({
  currency,
  onOpenAccount,
  onCancelTransfer,
}: CurrencyAccountNotFoundProps) => {
  return (
    <Stack space={3} align="stretch" className="w-full rounded-b-lg bg-muted p-5">
      <Inline justify="center">
        <div className="h-5 w-5">
          <TriangleAlert className="h-full w-full" color="#FF531D" />
        </div>

        <p className="text-center text-base font-medium text-black">{`You don't have an account in ${currency}`}</p>
      </Inline>

      <Inline space={2}>
        <Button variant="default" onClick={onOpenAccount} className="flex-1">
          {`Save as draft and open ${currency} account`}
        </Button>

        <Button variant="destructive" onClick={onCancelTransfer}>
          Cancel transfer
        </Button>
      </Inline>
    </Stack>
  );
};
